import { Heart, Zap, Shield, Building2, Building, Cpu, Video, Award, CheckCircle, Users, PartyPopper, FileText } from 'lucide-react'

export interface NewsItem {
  id: string
  category: '项目案例' | '公司新闻' | '行业资讯' | '技术动态' | '媒体报道' | '产品发布'
  title: string
  excerpt: string
  content: string
  date: string
  icon: any
  color: string
  link?: string
}

export const newsData: NewsItem[] = [
  {
    id: 'news-021',
    category: '项目案例',
    title: '乌审旗医共体智慧 120 项目正式上线',
    excerpt: '音质科技医疗信息化项目——智慧 120 院前急救系统在乌审旗医共体圆满落地，并已正式上线运行',
    content: '近日，音智科技承建的乌审旗医共体智慧 120 项目正式上线运行。该项目部署了音智智能语音调度系统，实现急救电话的智能接听、快速定位、自动分诊等功能。系统上线后，急救响应时间大幅缩短，有效提高了急救成功率，为当地居民提供更加高效便捷的院前急救服务。',
    date: '2026-02-24',
    icon: Heart,
    color: 'from-blue-500 to-cyan-500',
    link: 'https://mp.weixin.qq.com/s/xsJQUd0ph25IC7FeEEz9vg',
  },
  {
    id: 'news-020',
    category: '产品发布',
    title: '静守产品业绩版图点亮河北',
    excerpt: '静守防欺凌智能预警终端、健康守护终端等设备成功落地衡水三所学校，助力校园防欺凌与控烟体系建设',
    content: '音智科技静守™系列产品正式进入河北市场，成功落地衡水市三所学校。本次部署的产品包括静守防欺凌智能预警终端和健康守护终端（控烟监测），将帮助学校构建全方位的校园安全防控体系，为学生健康成长提供智能化保障。',
    date: '2026-02-15',
    icon: Zap,
    color: 'from-green-500 to-teal-500',
    link: 'https://mp.weixin.qq.com/s/bQ3iTaCEBaPSoP-dyASuiQ',
  },
  {
    id: 'news-019',
    category: '项目案例',
    title: '从"点"到"面"：达拉特旗校园安全防控体系全面升级',
    excerpt: '达拉特旗第二中学、第六中学、第八中学、第九中学、第十一中学五所重点学校全面部署静守智能预警终端与健康守护终端',
    content: '内蒙古鄂尔多斯达拉特旗校园安全防控体系迎来全面升级。达拉特旗第二中学、第六中学、第八中学、第九中学、第十一中学五所重点学校同时部署音智科技静守™智能预警终端和健康守护终端，标志着达拉特旗校园安全工作从"试点"走向"全覆盖"，为全旗学生提供更加全面的智能化安全保障。',
    date: '2025-12-30',
    icon: Shield,
    color: 'from-purple-500 to-pink-500',
    link: 'https://mp.weixin.qq.com/s/Q-SPvjtuRadHRzYtF7R2eA',
  },
  {
    id: 'news-018',
    category: '项目案例',
    title: '静守产品落地鄂尔多斯达拉特旗',
    excerpt: '鄂尔多斯达拉特旗第五中学在隐蔽场所全面覆盖校园防欺凌产品静守 JS810，同时在隐蔽场所全面安装健康守护终端监测学生吸烟行为',
    content: '鄂尔多斯达拉特旗第五中学引入音智科技静守™JS810 增强款防欺凌预警终端，在校园卫生间等隐蔽场所实现全面覆盖。同时部署健康守护终端，实时监测学生吸烟等违规行为。系统运行以来，已成功预警多起潜在欺凌事件和吸烟行为，得到学校和家长的高度认可。',
    date: '2025-08-12',
    icon: Building2,
    color: 'from-indigo-500 to-purple-500',
    link: 'https://mp.weixin.qq.com/s/hgczqCP30wRwU16IY3nw6Q',
  },
  {
    id: 'news-017',
    category: '项目案例',
    title: '大连交通技师学院以科技力量构筑校园安全智能防线',
    excerpt: '大连交通技师学院在宿舍区部署静守 JSJK119 健康守护终端和静守 JSX86 防欺凌智能预警终端，全面提升校园安全防控能力',
    content: '大连交通技师学院引入音智科技静守™系列产品，在学生宿舍区大规模部署 JSJK119 健康守护终端和 JSX86 防欺凌智能预警终端。通过 AI 语音识别技术，实现对宿舍区域的全天候智能监测，及时发现并处置各类安全隐患，为师生营造安全和谐的学习生活环境。',
    date: '2025-03-01',
    icon: Building,
    color: 'from-tech-500 to-blue-500',
    link: 'https://mp.weixin.qq.com/s/eleD7oWcNtFwPb1iARqWpA',
  },
  {
    id: 'news-016',
    category: '技术动态',
    title: '音智科技推出 DeepSeek 全面服务',
    excerpt: '静守拥抱 DeepSeek，音智提供全套大模型解决方案',
    content: '音智科技宣布推出基于 DeepSeek 大模型的全套解决方案，将先进的通用大模型能力与静守™系列产品的专业场景深度融合。新方案将在语义理解、情感分析、智能对话等方面带来显著提升，为校园安全和政企数字化转型提供更强大的 AI 赋能。',
    date: '2025-02-19',
    icon: Cpu,
    color: 'from-orange-500 to-red-500',
    link: 'https://mp.weixin.qq.com/s/oe5tjCHAIDRgpf-_FqqcPw',
  },
  {
    id: 'news-015',
    category: '项目案例',
    title: '静守防欺凌联动视频能力共建安全校园',
    excerpt: '鄂尔多斯市第二中学全校 100 多个卫生间全面覆盖静守产品，联动摄像头对报警事件进行事后溯源',
    content: '鄂尔多斯市第二中学建成完善的校园安全防控体系，在全校 100 多个卫生间部署静守™防欺凌预警终端，并与视频监控系统实现联动。当静守系统检测到异常事件时，可自动调取相关视频录像，为事件处置和溯源提供有力支撑，大幅提升校园安全管理效率。',
    date: '2025-01-03',
    icon: Video,
    color: 'from-cyan-500 to-blue-500',
    link: 'https://mp.weixin.qq.com/s/6h3HJ_WqA0OhOOfpPN_4jg',
  },
  {
    id: 'news-014',
    category: '项目案例',
    title: '静守雷达语音融合 AI 产品落地准格尔旗教体局',
    excerpt: '音智科技中标并验收内蒙古鄂尔多斯准格尔旗教育体育局防霸凌预警平台及设备采购项目',
    content: '音智科技成功中标内蒙古鄂尔多斯准格尔旗教育体育局防霸凌预警平台及设备采购项目，并顺利通过验收。该项目采用创新的雷达 + 语音融合 AI 技术，实现对人体行为和语音信息的双重监测，大幅提升欺凌行为识别的准确率和及时性，为准格尔旗各中小学校园安全保驾护航。',
    date: '2024-12-24',
    icon: Award,
    color: 'from-yellow-500 to-orange-500',
    link: 'https://mp.weixin.qq.com/s/xFNf7xyQOA97WSogbvlfHw',
  },
  {
    id: 'news-013',
    category: '项目案例',
    title: '辽宁两所学校部署静守防欺凌产品',
    excerpt: '静守系列产品落地沈阳沈师二校、于洪职教中学，守护校园安全',
    content: '音智科技静守™系列产品在辽宁省再传捷报，成功落地沈阳市师范大学第二附属学校和于洪区职业教育中学。两所学校均部署了静守防欺凌智能预警终端，利用 AI 语音识别技术实时监测异常情况，及时预警干预，为师生营造安全和谐的校园环境。',
    date: '2024-11-04',
    icon: CheckCircle,
    color: 'from-green-600 to-green-400',
    link: 'https://mp.weixin.qq.com/s/jBeSfdqCPA0AEKihXe_KhQ',
  },
  {
    id: 'news-012',
    category: '项目案例',
    title: '烟感联动防欺凌 兴平市十一建学校校园安全上升新高度',
    excerpt: '陕西省兴平市十一建学校部署静守防欺凌 + 烟感产品联动守护校园安全',
    content: '陕西省兴平市第十一初级中学引入音智科技静守™防欺凌预警系统和烟感监测设备，实现两大系统的联动协同。当系统检测到欺凌行为或吸烟情况时，可同时触发告警并通知相关人员，形成全方位、多维度的校园安全防护网，有效提升校园安全管理水平。',
    date: '2024-09-26',
    icon: Shield,
    color: 'from-red-500 to-pink-500',
    link: 'https://mp.weixin.qq.com/s/-56F0JEcDaRXL7kXAM3YzQ',
  },
  {
    id: 'news-011',
    category: '项目案例',
    title: '威海市城里中学引入静守产品，筑牢校园安全防线',
    excerpt: '山东省威海市城里中学部署静守防欺凌产品，加强校园安全防控体系',
    content: '山东省威海市城里中学与音智科技达成合作，在校内部署静守™防欺凌智能预警终端。系统利用先进的 AI 语音识别技术，实时监测校园内的异常情况，及时发现并预警潜在的欺凌行为，为学校安全管理提供智能化技术支持，受到师生和家长的一致好评。',
    date: '2024-09-01',
    icon: Building2,
    color: 'from-blue-600 to-blue-400',
    link: 'https://mp.weixin.qq.com/s/QYkwUfpNbzbzDg4tD54Jlw?poc_token=HIweummjLz1n9cgEO7FveSoxfkIBkj3WrPvCWXdD',
  },
  {
    id: 'news-010',
    category: '项目案例',
    title: '威海市南山小学：加强校园安全防控，引入静守防欺凌产品',
    excerpt: '山东省威海市南山小学部署静守产品加强校园安全防控能力',
    content: '威海市南山小学引入音智科技静守™系列产品，全面加强校园安全防控能力建设。通过在学生活动区域部署智能预警终端，学校实现了对校园安全事件的实时监测和快速响应，有效预防和减少了校园欺凌等安全事件的发生，为学生健康成长营造良好环境。',
    date: '2024-08-20',
    icon: Users,
    color: 'from-purple-600 to-purple-400',
    link: 'https://mp.weixin.qq.com/s/_bLxnG2xG9mhPBXQMfEeLw',
  },
  {
    id: 'news-009',
    category: '项目案例',
    title: '西安海棠技师学院：未雨绸缪，引入防欺凌产品守护校园安全',
    excerpt: '静守助力西安海棠技师学院针对学生宿舍进行校园预警方案全面升级',
    content: '西安海棠技师学院高度重视校园安全工作，引入音智科技静守™防欺凌预警系统，针对学生宿舍区域进行全面升级改造。系统部署后，可实现对学生宿舍的全天候智能监测，及时发现并处置各类安全隐患，为学生提供安全舒适的生活环境。',
    date: '2024-08-03',
    icon: Building,
    color: 'from-indigo-600 to-indigo-400',
    link: 'https://mp.weixin.qq.com/s/OuDvKLLJ9qi5SYap3ME21Q',
  },
  {
    id: 'news-008',
    category: '产品发布',
    title: '静守家族系列产品震撼发布，开启校园安全新时代',
    excerpt: '今天，静守家族系列产品再添多位新成员，全面守护青少年健康成长',
    content: '音智科技正式发布静守™家族系列多款新产品，包括 JS810 增强款、JSX86 旗舰款防欺凌预警终端以及 JSJK119 健康守护终端等。新产品在识别准确率、响应速度、功能丰富度等方面均有显著提升，将进一步丰富校园安全产品线，为不同场景需求提供多样化选择。',
    date: '2024-07-28',
    icon: PartyPopper,
    color: 'from-pink-600 to-pink-400',
    link: 'https://mp.weixin.qq.com/s/I-XS1L9UgEw4W9fYIPWDEw',
  },
  {
    id: 'news-007',
    category: '媒体报道',
    title: '[视频采访] 静守防欺凌预警设备受到用户好评',
    excerpt: '静守 JS800 助力鄂尔多斯鄂托克旗乌兰镇中学针对校园隐蔽场所进行校园预警方案全面升级',
    content: '媒体对鄂尔多斯鄂托克旗乌兰镇中学进行专访报道，该校引入音智科技静守™JS800 标准款防欺凌预警终端后，校园安全管理工作取得显著成效。学校负责人表示，静守产品有效提升了校园安全防控能力，为预防校园欺凌提供了有力的技术支撑，值得推广应用。',
    date: '2024-05-12',
    icon: Video,
    color: 'from-red-600 to-red-400',
    link: 'https://mp.weixin.qq.com/s/LSKya1nkAX-ZTWWXdOqeEw',
  },
  {
    id: 'news-006',
    category: '公司新闻',
    title: '音智防欺凌产品荣获双创奖项',
    excerpt: '大连音智科技有限公司凭借其在声学和人工智能领域的创新技术，荣获第十二届中国创新创业大赛"初创企业组"二等奖，并入围全国赛半决赛',
    content: '在第十二届中国创新创业大赛中，大连音智科技有限公司凭借静守™防欺凌预警系统的创新技术和应用价值，荣获"初创企业组"二等奖，并成功入围全国赛半决赛。这是对公司技术创新能力和产品社会价值的高度认可，也将激励音智科技继续深耕 AI 语音领域，创造更大价值。',
    date: '2024-04-27',
    icon: Award,
    color: 'from-amber-500 to-orange-500',
    link: 'https://mp.weixin.qq.com/s/YsFcLn-_Pxp9BDiYoETE-A',
  },
  {
    id: 'news-005',
    category: '行业资讯',
    title: '校园霸凌我来治',
    excerpt: '近期，校园欺凌事件频发，引发了社会的广泛关注。从河北邯郸的悲剧到全国各地的校园安全问题，我们不禁要问：如何守护孩子们的健康成长？',
    content: '近期多地发生校园欺凌事件，引发社会强烈关注。如何利用科技手段预防和治理校园欺凌成为热点话题。音智科技静守™系列产品通过 AI 语音识别技术，实现对校园欺凌行为的实时监测和预警，为构建平安校园提供了新的解决思路和技术手段。',
    date: '2024-04-17',
    icon: FileText,
    color: 'from-slate-500 to-slate-400',
    link: 'https://mp.weixin.qq.com/s/VkIYueiszScPaSG03OSbHg',
  },
  {
    id: 'news-004',
    category: '项目案例',
    title: '静守助力乌兰镇中学构建安全校园',
    excerpt: '静守 JS800 助力鄂尔多斯鄂托克旗乌兰镇中学针对校园隐蔽场所进行校园安全预警方案全面升级',
    content: '鄂尔多斯鄂托克旗乌兰镇中学引入音智科技静守™JS800 标准款防欺凌预警终端，对校园卫生间等隐蔽场所进行安全预警方案全面升级。系统运行以来，成功预警并处置多起潜在欺凌事件，有效维护了校园安全稳定，得到教育主管部门和学校的高度评价。',
    date: '2023-12-19',
    icon: Shield,
    color: 'from-green-500 to-emerald-500',
    link: 'https://mp.weixin.qq.com/s/EGSJvfuTOPKQ-ouomLD-1A',
  },
  {
    id: 'news-003',
    category: '公司新闻',
    title: '静心陪伴，守护你我，共筑安全校园',
    excerpt: '在这个信息时代，我们格外关心营造一个安全的校园环境，以保护孩子们的安全。为此，我们引入了先进的技术——基于人工智能的语音识别技术，构建了智能预警平台',
    content: '音智科技始终关注校园安全问题，依托先进的人工智能语音识别技术，打造静守™智能预警平台。该平台能够实时监测校园环境中的异常情况，及时预警干预，为构建安全和谐的校园环境提供技术支撑。我们愿与社会各界携手，共同守护青少年健康成长。',
    date: '2023-10-28',
    icon: Heart,
    color: 'from-pink-500 to-rose-500',
    link: 'https://mp.weixin.qq.com/s/CAd6zx0o4tTD7N4eqRaNIg',
  },
  {
    id: 'news-002',
    category: '行业资讯',
    title: '令人发指：山西大同校园霸凌事件',
    excerpt: '近日，山西省大同市大成双语学校一家长在网上发文，称自己四年级的儿子在校一年半时间内一直遭到同班同宿舍的同学赵某某霸凌',
    content: '山西大同某学校发生校园欺凌事件，引发社会广泛关注。此类事件再次凸显校园安全防控工作的重要性。音智科技呼吁社会各界重视校园安全问题，积极采用先进技术手段，如静守™防欺凌预警系统，共同构建安全和谐的校园环境，保护每一位学生的身心健康。',
    date: '2023-09-25',
    icon: FileText,
    color: 'from-gray-500 to-gray-400',
    link: 'https://mp.weixin.qq.com/s/kXRCb8QYvej0zsYxoLGeAA',
  },
  {
    id: 'news-001',
    category: '公司新闻',
    title: '这个教师节，送上不一样的礼物',
    excerpt: '教师节到了，让我们一起感谢那些默默耕耘、辛勤付出的老师们',
    content: '在第 39 个教师节来临之际，音智科技向全国广大教育工作者致以节日问候和崇高敬意。作为校园安全领域的科技企业，我们将继续秉承"科技守护校园"的理念，不断创新产品和服务，为广大师生提供更加安全、智能的校园环境，这是对老师最好的节日礼物。',
    date: '2023-09-10',
    icon: PartyPopper,
    color: 'from-violet-500 to-purple-500',
    link: 'https://mp.weixin.qq.com/s/3FKWrqHwMj4HFErRuqelyQ',
  },
]

export const getLatestNews = (limit: number = 3) => {
  return [...newsData]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit)
}
